import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {EntityType} from 'nutshell-graphql-types';
import type {
    GetSelectableCustomFields as GetSelectableCustomFieldsQuery,
    GetSelectableCustomFields_customFields_active as CustomFields,
    GetSelectableCustomFieldsVariables,
} from 'nutshell-graphql-types';

import GET_SELECTABLE_CUSTOM_FIELDS from '../queries/get-selectable-custom-fields.graphql';

export const useGetSelectableCustomFields = (
    entityType: EntityType
): {
    customFields: CustomFields[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetSelectableCustomFieldsQuery,
        GetSelectableCustomFieldsVariables
    >(GET_SELECTABLE_CUSTOM_FIELDS, {
        variables: {
            input: {
                entityType,
            },
        },
    });

    return {
        customFields: data && data.customFields && data.customFields.active,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
